const A = Array

export const isArray = A.isArray
